// As contas das frases de resumo de cada seccao (spec do redesign, R7): partes de um total que a pagina
// ja tem na mao, arredondadas a unidades, porque uma frase le-se melhor com "62%" do que com "62,1%".
// Sem total devolvem null, e a frase nao aparece.
const sumOf = (values, keys) => keys.reduce((sum, key) => sum + (values[key] || 0), 0);

export const roundedShare = (part, total) => (total ? Math.round((100 * part) / total) : null);

// Por defeito, para a frase que tem por baixo o que fica de fora: 995 de 1000 arredondava a "100%" por cima de
// linhas que nao sao zero, e por defeito le-se 99%.
export const flooredShare = (part, total) => (total ? Math.floor((100 * part) / total) : null);

export const startsShares = (firstSource) =>
  firstSource.total
    ? {
        typed: roundedShare(firstSource.values.typed || 0, firstSource.total),
        suggestion: roundedShare(firstSource.values.quick_reply || 0, firstSource.total),
        voice: roundedShare(firstSource.values.voice || 0, firstSource.total),
      }
    : null;

export const endingsShares = (close) =>
  close.total
    ? {
        inactivity: roundedShare(close.values.inactivity || 0, close.total),
        customer: roundedShare(sumOf(close.values, ["customer_header", "customer_agent_button"]), close.total),
        operator: roundedShare(close.values.operator || 0, close.total),
      }
    : null;

// As conversas em que o assistente teve o perfil do cliente, sobre todas (as sem informacao tambem contam no total).
export const knownShare = (conversations) => (conversations.total ? roundedShare(conversations.values.known || 0, conversations.total) : null);

// As pesquisas por tamanho em que o assistente pediu os tamanhos ao cliente: o missing e o section. O no_gender
// pergunta para quem e, nao o tamanho (D9).
export const askedForSizesShare = (searches) => (searches.total ? roundedShare(sumOf(searches.values, ["missing", "section"]), searches.total) : null);

// As conversas com operador que tiveram resposta em menos de 5 minutos, sobre todas as que chegaram a um.
export const fastReplyShare = (replies) => (replies.total ? roundedShare(sumOf(replies.values, ["0-1m", "1-5m"]), replies.total) : null);

// O maior valor de uma serie e onde esta. Uma serie a zero nao tem pico.
export const peakOf = (values) => {
  const value = Math.max(0, ...values);
  return value > 0 ? { index: values.indexOf(value), value } : null;
};
